import { useState, useEffect, useCallback } from 'react';
import { Pane, Heading, Table, Spinner, Text } from 'evergreen-ui';
import { getSuspiciousAttempts } from '../services/loginHistoryService';
import { formatDeviceInfo } from '../utils/parseUserAgent';

const formatDateTime = (value) => {
    const d = new Date(value.replace(' ', 'T'));
    if (isNaN(d.getTime())) return value;
    return d.toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

const SuspiciousAttempts = () => {
    const [attempts, setAttempts] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchAttempts = useCallback(async () => {
        setLoading(true);
        try {
            const data = await getSuspiciousAttempts();
            setAttempts(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { fetchAttempts(); }, [fetchAttempts]);

    return (
        <Pane elevation={1} padding={16} marginTop={24} background="tint1" borderRadius={4}>
            <Heading size={500} marginBottom={4}>Tentativi sospetti</Heading>
            <Text size={300} color="muted" display="block" marginBottom={12}>
                Tentativi di accesso con l'email di un account rimosso.
            </Text>
            {loading ? (
                <Spinner size={24} />
            ) : attempts.length === 0 ? (
                <Text>Nessun tentativo sospetto registrato.</Text>
            ) : (
                <Table>
                    <Table.Head>
                        <Table.TextHeaderCell>Data/ora</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Email</Table.TextHeaderCell>
                        <Table.TextHeaderCell>IP</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Dispositivo</Table.TextHeaderCell>
                    </Table.Head>
                    <Table.Body>
                        {attempts.map(attempt => (
                            <Table.Row key={attempt.id}>
                                <Table.TextCell>{formatDateTime(attempt.attempted_at)}</Table.TextCell>
                                <Table.TextCell>{attempt.email}</Table.TextCell>
                                <Table.TextCell>{attempt.ip_address}</Table.TextCell>
                                <Table.TextCell>{formatDeviceInfo(attempt.user_agent)}</Table.TextCell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            )}
        </Pane>
    );
};

export default SuspiciousAttempts;
